
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import {Link} from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Der Geschichtsprofessor A. Roger Ekirch von der Virginia Tech Universität veröffentlichte 2001 eine `}<Link href='https://www.sleep.theclinics.com/article/S1556-407X(11)00085-3/abstract' mdxType="Link">{`Studie`}</Link>{`, in der er seine Ergebnisse über das Schlafverhalten aus 16 Jahren Forschung vorstellte. Der heute gängige acht Stunden Schlaf kennt man eigentlich er seit der Industrialisierung. In seinem 2005 veröffentlichten Buch «At Day’s Close: Night in Times Past» untermauert Ekirch seine These, dass die Menschen zwischen 1500 und 1750 ganz selten am Stück schliefen, sondern in verschiedenen Etappen über eine längere Periode von ungefähr 12 Stunden hinweg. Ein erster Schlaf dauerte jeweils drei bis vier Stunden. Danach waren die Menschen wieder aktiv, und nutzen die Zeit um sich im Schlafzimmer mit allerlei vergnüglichen Dingen und Beschäftigungen die Zeit zu vertreiben. Oder sie statteten den Nachbarn einen kurzen Besuch ab, um sich danach wieder zurückzuziehen um weiterzuschlafen. Ende des 17. Jahrhunderts verschwanden die verschiedenen Schlafphasen in der urbanen Oberschicht Nordeuropas. In den folgenden 200 Jahren galt dies für die ganze westliche Gesellschaft. Und ab 1920 verlor das Konzept des Episodenschlafes seine Bedeutung.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;